<div *ngIf="print.load" class="body-wrapper rtl">
  <header class="header" *ngIf="print.questionnaire">
    <img
      [src]="logoUrl"
      alt="Logo"
      class="header-logo"
      onerror="this.style.display='none'"
    />
    <h1 class="header-title">{{ print.questionnaire.questionnaireName }}</h1>
    <div class="header-details">
      <span *ngIf="print.questionnaire.patient?.first || print.questionnaire.patient?.last">
        <dt>שם</dt>
        <dd>{{ print.questionnaire.patient.first }} {{ print.questionnaire.patient.last }}</dd>
      </span>
      <span *ngIf="print.questionnaire.patient?.id">
        <dt>ת.ז.</dt>
        <dd>{{ print.questionnaire.patient.id }}</dd>
      </span>
      <span *ngIf="print.questionnaire.examCode">
        <dt>סוג בדיקה</dt>
        <dd>{{ print.questionnaire.examCode }}</dd>
      </span>
      <span *ngIf="print.questionnaire.answeredDate">
        <dt>תאריך מענה</dt>
        <dd>{{ print.questionnaire.answeredDate | date: 'dd.MM.yyyy HH:mm' }}</dd>
      </span>
    </div>
  </header>
  <main class="main">
    <section class="section" *ngIf="print.questionnaire">
      <table class="answers-table" *ngIf="print.questionnaire.answers?.length">
        <thead>
          <tr>
            <th style="width: 60%">שאלה</th>
            <th>תשובה</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let a of print.questionnaire.answers">
            <td>{{ a.questionTextSnapshot }}</td>
            <td>
              <img
                *ngIf="a.questionType === 'signature' && a.answerValue"
                [src]="a.answerValue"
                class="answer-signature"
                alt="signature"
              />
              <span *ngIf="a.questionType !== 'signature'">{{ a.answerValue }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="empty-note" *ngIf="!print.questionnaire.answers?.length">
        אין תשובות שמורות עבור שאלון זה.
      </p>
    </section>
  </main>
</div>
